import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

document.querySelectorAll('[data-slider]').forEach(slider => {

  const options = {
    modules: [Navigation],
    loop: false,
    autoHeight: true,
    allowTouchMove: false,
  };

  let interval = null;
  const itemCount = slider.querySelectorAll('.swiper-slide').length;
  const updateCurrentSlideElement = slider.querySelector('[data-update-current-slide]');

  if (itemCount > 1) {
    options.navigation = {
      nextEl: slider.querySelector('.swiper-button-next'),
      prevEl: slider.querySelector('.swiper-button-prev'),
    };
  } else {
    slider.classList.add('swiper-no-navigation');
  }

  if (slider.dataset.slidesperview) {
    options.slidesPerView = 1.5;
    options.spaceBetween = 50;
    options.allowTouchMove = true;

    options.breakpoints = {
      640: {
        slidesPerView: 2.5,
      },
      1024: {
        slidesPerView: slider.dataset.slidesperview,
        allowTouchMove: true,
      }
    }
  }

  if (slider.dataset.touch === 'always') {
    options.allowTouchMove = true;
  }

  if (slider.dataset.timer) {
    options.loop = true;
  }

  const swiper = new Swiper(slider.querySelector('.swiper'), options);

  if (slider.dataset.timer) {
    const timerInfo = slider.querySelector('[data-swiper-timer-info]');
    const timerAnimate = slider.querySelector('[data-swiper-timer-animate]')

    let timerLength = slider.dataset.timer  ?? 1000;
    let counter = 0;
    let steps = 1000

    interval = setInterval(e => {
      if (counter >= steps) {
        swiper.slideNext()
      }

      timerInfo.innerHTML = String(Math.round((timerLength - (counter * (timerLength / steps))) / 1000)).padStart(2, '0')
      timerAnimate.setAttribute('stroke-dashoffset', 1000 - (120 / steps * counter))

      counter++;
    }, timerLength / steps);

    swiper.on('slideChange', e => {
      counter = 0;
      if (updateCurrentSlideElement) {
        updateCurrentSlideElement.innerHTML = String(swiper.realIndex + 1).padStart(2, '0')
      }
    })
  }


})
